import axios from '../utils/axios'

// 代理加盟申请记录(审核人视角)
export function getAgentJoinList(params) {
  return axios.post('/user/apiUserAwService/getAgentJoinList', params)
}
//代理加盟申请详情
export function getAgentJoinDetailById(params) {
  return axios.post('/user/apiUserAwService/getAgentJoinDetailById', params)
}
